import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  companyCommissionApi,
  type UpdateCompanyCommissionInput,
} from "@/lib/company-commission.api";
import { queryKeys } from "@/lib/query-keys";

function useInvalidate() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.companyCommissions() });
    queryClient.invalidateQueries({ queryKey: queryKeys.companyCommissionBatches() });
    queryClient.invalidateQueries({ queryKey: queryKeys.companyCommissionStats() });
  };
}

export function useConsolidateCompanyCommissionsMutation() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ commissionIds, note }: { commissionIds: number[]; note?: string }) =>
      companyCommissionApi.consolidate(commissionIds, note).then((r) => r.data),
    onSuccess: (batch) => {
      toast.success(
        `Consolidation effectuée — ${batch.count} ligne(s), ${Number(batch.totalAmount).toLocaleString("fr-FR")} XAF.`,
      );
      invalidate();
    },
  });
}

export function useUpdateCompanyCommissionMutation() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: UpdateCompanyCommissionInput }) =>
      companyCommissionApi.update(id, patch).then((r) => r.data),
    onSuccess: () => {
      toast.success("Commission corrigée.");
      invalidate();
    },
  });
}
